/** @internal */
export const PLUGIN_HOST_CONTEXT = 'dxcore_pluginHost_context';
/** @internal */
export const POSITION_CONTEXT = 'dxcore_position_context';
/** @internal */
export const TEMPLATE_HOST_CONTEXT = 'dxcore_templateHost_context';

/** @internal */
export const RERENDER_TEMPLATE_EVENT = Symbol('rerenderTemplate');
/** @internal */
export const RERENDER_TEMPLATE_SCOPE_EVENT = Symbol('rerenderTemplateScope');
/** @internal */
export const UPDATE_CONNECTION_EVENT = Symbol('updateConnection');
